import { useLocation, Navigate } from "react-router-dom";

/**
 * Route element that permanently redirects legacy KIRA Markets URLs
 * to their KIRA Score equivalents by stripping the legacy brand prefix.
 * Example: /kira-markets/company/foo → /company/foo
 *          /kiramarkets/research/unlisted?x=1 → /research/unlisted?x=1
 *
 * Rendered by App.js for the routes:
 *   /kira-markets/*, /kiramarkets/*, /kira_markets/*, /kira-market/*
 * so React Router matches them BEFORE the catch-all "*" route.
 */
export function LegacyBrandRedirect() {
  const { pathname, search, hash } = useLocation();

  // Strip the leading legacy segment (e.g. "/kira-markets") and keep the rest.
  const rest = pathname.replace(/^\/(kira-markets|kiramarkets|kira_markets|kira-market)/i, "");
  const target = (rest || "/") + search + hash;
  return <Navigate to={target} replace />;
}
